import React from 'react';
import { Box } from '@mui/material';


// Coordinates for your location (replace with your specific location)


const MapComponent = () => {
  

  return (
    <Box
      sx={{
        width: '100%',
        height: '70vh',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
          <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d929.6817725350726!2d81.63109326960068!3d21.24266799877879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd003b12489f%3A0x897e714dca6706b9!2sGenius%20Industrial%20Training%20Institute%20And%20Management!5e0!3m2!1sen!2sin!4v1724662148943!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>

      
    
      
    </Box>
  );
};

export default MapComponent;
